import Typograf from 'typograf';

export const tp = new Typograf({ locale: ['ru', 'en-US'] });

tp.enableRule('common/nbsp/afterNumber');
tp.enableRule('common/nbsp/beforeShortLastNumber');
